var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");

var AbstractViewerController = editor_2d.AbstractViewerController;

var PropertyInteractionView = require("./propertyInteractionView.js");
var PropertyInteractionModel = require("./propertyInteractionModel.js");

var PropertyViewerController = function(archLayers, dependencies, configuration) {
    AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(PropertyViewerController, AbstractViewerController);
PropertyViewerController.inject = AbstractViewerController.inject;

module.exports = PropertyViewerController;

PropertyViewerController.prototype.beforeLoad = function () {
    AbstractViewerController.prototype.beforeLoad.call(this);
};

PropertyViewerController.prototype.getDataType = function () {
    return cio_datamodel.PropertyData;
};

PropertyViewerController.prototype.getInteractionViewType = function () {
    return PropertyInteractionView;
};

PropertyViewerController.prototype.getInteractionModelType = function () {
    return PropertyInteractionModel;
};
